import React from 'react';
import {Button, BUTTON_VARIANT, COLOR, Icon, Layout, SPACE, Text, useDevice, View} from '@lookiero/aurora';

import {useIntl} from '@/modules/I18N';
import {scrollToQuiz} from '@/pages/Home/services';
import {useMendelContext} from '@/modules/ABTesting';
import {styles} from '../../Intro.styles';
import {IDS, TEXT} from '../../intro.definition';
import {Banner, TrustPilot} from '@/pages/Home/components/Intro/components';
import {getIntroConfig} from '@/pages/Home/components/Intro/services/getIntroConfig';

const {content, images} = getIntroConfig();

const IntroContentV2: React.FC = () => {
  const {screen} = useDevice();
  const {formatMessage} = useIntl();

  const {freeTrial} = useMendelContext();
  const expText = freeTrial.text?.cta;
  const CTA_TEXT = expText ? {id: expText} : content.cta;

  const bullets = [
    {
      defaultMessage: 'Get 5 items chosen for you.',
      id: 'exp_afterwork1',
    },
    {defaultMessage: 'Only pay for what you keep.', id: 'exp_afterwork2'},
    {defaultMessage: 'Free delivery and returns.', id: 'exp_afterwork3'},
  ];

  return (
    <View
      as="section"
      style={[
        screen.L && styles.content,
        screen.L && styles.contentDesktop,
        screen.L && styles.contentDesktopReducedATFExperiment,
        !screen.L && styles.contentReducedATFExperimentV2,
      ]}
      nativeID="content-section"
    >
      {screen.L && <Banner />}
      <Layout
        fullWidth={screen.L}
        style={[styles.contentTop, screen.L && styles.contentTopDesktop]}
        marginBottom={
          images.trustpilot
            ? {
                S: 0,
                M: 0,
              }
            : !screen.L
            ? SPACE.SPACE_6
            : SPACE.SPACE_8
        }
        marginTop={SPACE.SPACE_8}
      >
        <Text
          color={!screen.L ? COLOR.TEXT_LIGHT : COLOR.TEXT}
          heading
          level={screen.L ? 2 : 3}
          marginBottom={{
            L: SPACE.SPACE_6,
            default: SPACE.SPACE_1,
          }}
          nativeID={IDS.TITLE}
        >
          {formatMessage(TEXT.TITLE)}
        </Text>
        <View
          style={[
            screen.L && styles.contentBullets,
            !screen.L && styles.contentBulletsReducedATFExperimentV2,
            screen.L && styles.contentBulletsDesktop,
          ]}
          nativeID={IDS.BULLETS}
        >
          {bullets.map(bullet => (
            <View style={styles.bullets} key={bullet.id}>
              <Icon
                color={!screen.L ? COLOR.ICON_ON_PRIMARY : undefined}
                name={!screen.L ? 'tick' : 'tick_fill'}
                style={!screen.L ? styles.bulletIconReducedATFExperimentV2 : styles.bulletIcon}
              />
              <Text color={!screen.L ? COLOR.TEXT_LIGHT : COLOR.TEXT} detail={!screen.L} level={screen.L ? 3 : 1}>
                {formatMessage(bullet)}
              </Text>
            </View>
          ))}
        </View>
        <Button
          nativeID={IDS.CTA}
          style={[screen.L && styles.cta, !screen.L && {height: 48}]}
          onPress={scrollToQuiz}
          variant={!screen.L ? BUTTON_VARIANT.PRIMARY_LIGHT : BUTTON_VARIANT.PRIMARY}
        >
          {!screen.L ? (
            <>
              <Text action level={3} marginRight={SPACE.SPACE_2}>
                {formatMessage(CTA_TEXT)}
              </Text>
              <ArrowRightIcon />
            </>
          ) : (
            formatMessage(CTA_TEXT)
          )}
        </Button>
        <TrustPilot />
      </Layout>
    </View>
  );
};

const ArrowRightIcon = () => {
  return (
    <View>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.7071 4.29289C12.3166 3.90237 11.6834 3.90237 11.2929 4.29289C10.9024 4.68342 10.9024 5.31658 11.2929 5.70711L16.5858 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H16.5858L11.2929 18.2929C10.9024 18.6834 10.9024 19.3166 11.2929 19.7071C11.6834 20.0976 12.3166 20.0976 12.7071 19.7071L19.7064 12.7078C19.7088 12.7054 19.7112 12.703 19.7136 12.7005C19.8901 12.5208 19.9992 12.2746 20 12.003C20 12.002 20 12.001 20 12C20 11.999 20 11.998 20 11.997C19.9996 11.8625 19.9727 11.7343 19.9241 11.6172C19.8764 11.502 19.8063 11.3938 19.7136 11.2995C19.7112 11.297 19.7089 11.2947 19.7065 11.2923M19.7065 11.2923L12.7071 4.29289Z"
          fill="#0C0A0A"
        />
      </svg>
    </View>
  );
};

const MemoizedIntroContentV2 = React.memo(IntroContentV2);
export {MemoizedIntroContentV2 as IntroContentV2};
